// as this component loads asyncronously add css here to not affect main bundle
export const getDefaultTheme = (css: string | undefined) => ({
  css: `
    .hs-form { min-width: 300px; }
    .hs-form-field { margin-top: 1rem; }
    ${css}
  `,
  submitButtonClass: 'btn btn-brand box-shadow-md m-t-1_5',
  errorMessageClass: 'text-error small list-unstyled p-t-0_3',
  errorClass: 'form-control-error',
});
